module.exports = __webpack_public_path__ + "static/atm-72c61f8957fa6e0eb84226d4856d0f2e.jpg";